import React, { Fragment } from "react"
import styled from "react-emotion"
import { getList } from "../blockTypes"
import Draggable from "../dnd/Draggable"
import MenuSection from "../ui/MenuSection"
import { Container, Collapsible, Text, Icon8, Input } from "ui"

import { ThemeProvider } from "emotion-theming"
import smallDarkTheme from "../ui/smallDarkTheme"
import WithActions from "data/wrappers/WithActions"
import WithBlocks from "data/wrappers/WithBlocks"
import WithCompounds from "data/wrappers/WithCompounds"
import ContainerBlockType from "../blockTypes/layout/Container"
import CustomBlockType from "../blockTypes/other/CustomBlock"

const blocks = getList()

class AddBlockPane extends React.Component {
    state = { search: null }
    filter = search => {
        if (!search) this.setState({ search: "" })
        this.setState({ search })
    }

    render() {
        const advancedMode = localStorage.getItem("advancedMode") === "on"

        return (
            <div>
                <Container padding="small">
                    <Input
                        innerRef={input => input && input.focus()}
                        onChange={e => this.filter(e.target.value)}
                    />
                </Container>
                <WithCompounds>
                    {({ compounds }) => {
                        const compoundBlocks = {
                            name: "Premade",
                            blocks: compounds.map(compoundToBlock),
                        }
                        return (
                            <WithBlocks>
                                {data => {
                                    const customBlocks = {
                                        name: "Custom Blocks",
                                        blocks: (data.blocks || []).map(customBlocktoBlock),
                                    }

                                    return (
                                        <WithActions>
                                            {({ actions }) => {
                                                const actionBlocks = {
                                                    name: "Actions",
                                                    blocks: actions.map(actionToFormBlock),
                                                }

                                                var blockList = [
                                                    ...blocks,
                                                    customBlocks,
                                                    compoundBlocks,
                                                ]
                                                if (advancedMode) {
                                                    blockList.push(actionBlocks)
                                                }

                                                return (
                                                    <ThemeProvider theme={smallDarkTheme}>
                                                        <Fragment>
                                                            {this.renderBlocksFromList(blockList)}
                                                        </Fragment>
                                                    </ThemeProvider>
                                                )
                                            }}
                                        </WithActions>
                                    )
                                }}
                            </WithBlocks>
                        )
                    }}
                </WithCompounds>
            </div>
        )
    }

    renderBlocksFromList = blockList => {
        var sections = blockList
        if (!localStorage.getItem("advancedMode") === "on")
            sections = sections.filter(section => section.hide !== true)
        return sections.map(({ name, blocks }) => (
            <Collapsible
                container={MenuSection(name, {
                    padding: "none",
                    margin: "none",
                })}
                key={name}
                defaultOpen
            >
                <Container margin="none" padding="none" wrapItems>
                    {blocks
                        .filter(block => !block.deprecated)
                        .filter(
                            ({ label }) =>
                                !this.state.search ||
                                label.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                        )
                        .map(
                            (
                                { label, icon, blockElement, blockTemplate, id, defaultConfig },
                                index
                            ) => (
                                <Draggable
                                    key={index}
                                    payload={{
                                        blockElement,
                                        blockTemplate,
                                        defaultConfig,
                                        id,
                                    }}
                                    onDragStart={this.props.hide}
                                    onDragEnd={this.props.close}
                                >
                                    {({ getRootProps, dnd }) => (
                                        <BlockTemplate {...getRootProps()}>
                                            <Icon8
                                                large
                                                noMargin
                                                icon={icon || "block"}
                                                draggable={false}
                                            />
                                            <Text>{label}</Text>
                                        </BlockTemplate>
                                    )}
                                </Draggable>
                            )
                        )}
                </Container>
            </Collapsible>
        ))
    }
}
export default AddBlockPane

const BlockTemplate = styled("div")`
    display: inline-block;
    height: 100px;
    width: 33%;
    cursor: grab;
    padding: 20px 0px;
    border: 1px solid #2c313c;
    text-align: center;
`
const customBlocktoBlock = block => {
    return {
        id: "template_" + sanitize(block.name),
        label: block.name,
        blockElement: CustomBlockType,
        blockTemplate: {
            type: "custom_block",
            config: {
                attributes: { block_id: block._sid },
                style: { default: { width: "100%" } },
            },
        },
    }
}

const sanitize = string =>
    string
        .split(" ")
        .join("_")
        .toLowerCase()

const actionToFormBlock = action => {
    return {
        id: "template_" + action._sid,
        label: action.description,
        blockElement: ContainerBlockType,
        blockTemplate: {
            type: "form",
            local_id: "form_" + action._sid,
            config: { attributes: { action: action._sid }, styles: {} },
            childBlocks: action.inputs
                .map(input => ({
                    type: "container",
                    childBlocks: [
                        {
                            type: "string",
                            config: {
                                attributes: { text: input.label },
                                style: {
                                    default: {},
                                },
                            },
                        },

                        {
                            type: "input",
                            config: {
                                attributes: { name: input.api_name },
                                style: {
                                    default: {},
                                },
                            },
                        },
                    ],
                }))
                .concat([
                    {
                        id: "button_" + action._sid,
                        type: "button",
                        config: {
                            style: {
                                default: {
                                    layout: "tight",
                                },
                            },
                            broadcast: [],
                            attributes: {
                                type: "primary",
                                buttonTitle: "Submit",
                                action: "form_" + action._sid + ".action.submit",
                            },
                        },
                        local_id: "button_0",
                        childBlocks: [],
                    },
                ]),
        },
    }
}

const compoundToBlock = compound => {
    console.log(compound)
    return {
        blockElement: ContainerBlockType,
        id: "template_" + compound._sid,
        type: compound.blocks && compound.blocks[0].type,
        label: compound.name,
        blockTemplate: compound.blocks && compound.blocks[0],
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/sidebars/AddBlockPane.js